// @ts-nocheck
import React, { useState, useEffect, forwardRef, useImperativeHandle, useContext } from "react";
import * as Enums from '@/utils/enums'
import SelectInput from "@/components/select-input";
import Checkbox from "@/components/checkbox";
import RadioInputGroup from "@/components/radio-input-group";
import Fetch from "@/utils/Fetch";
import KendoDatePicker from '@/components/kendo/kendo-date-picker';
import KendoMultiSelect from '@/components/kendo/kendo-multiselect';
import Time from "@/utils/time";
import Storage from '@/utils/storage';
import SCDatePicker from "@/components/sc-controls/form-controls/sc-datepicker";
import SCCheckbox from "@/components/sc-controls/form-controls/sc-checkbox";
import SCComboBox from "@/components/sc-controls/form-controls/sc-combobox";
import SCMultiSelect from "@/components/sc-controls/form-controls/sc-multiselect";
import SCRadioButtonGroup from "@/components/sc-controls/form-controls/sc-radio-button-group";
import SCRadioButton from "@/components/sc-controls/form-controls/sc-radio-button";
import helper from "@/utils/helper";
import SCDropdownList from "@/components/sc-controls/form-controls/sc-dropdownlist";
import StoreMultiSelector from "@/components/selectors/store/store-multiselector";
import CustomerSelector from "@/components/selectors/customer/customer-selector";
import InventorySelector from "@/components/selectors/inventory/inventory-selector";
import EmployeeSelector from "@/components/selectors/employee/employee-selector";
import JobStatusMultiSelector from "@/components/selectors/jobstatus/jobstatus-multiselector";
import QueryTypeSelector from "@/components/selectors/query/query-type-selector";
import QueryStatusSelector from "@/components/selectors/query/query-status-selector";
import SupplierSelector from "@/components/selectors/supplier-selector";

const ReportFilterInput = ({ template, updateValue, queryType, startDate }: any) => {

    const [inputValue, setInputValue] = useState(template.DefaultValue);
    const [inputType, setInputType] = useState<any>(null);
    const [inputDescription, setInputDescription] = useState(template.DefaultValue);
    const [selectSource, setSelectSource] = useState<any>(null); // "API" or "Enum"
    const [selectHelper, setSelectHelper] = useState<any>(null); // "<API endpoint>" or <Enum.Name>
    const [selectOptions, setSelectOptions] = useState<any>();
    const [selectType, setSelectType] = useState<any>(null); // for enum, enum, otherwise other types need to go here
    const [selectMultiple, setSelectMultiple] = useState(false);
    const [selectNoInput, setSelectNoInput] = useState(true);
    const [nullable, setNullable] = useState(true);
    const [selectParams, setSelectParams] = useState<any>({});
    const [selectSearchMethod, setSelectSearchMethod] = useState("post");
    const [selectedOptions, setSelectedOptions] = useState<any[]>([]);
    const [label, setLabel] = useState("");
    const [placeholder, setPlaceholder] = useState<any>(undefined)
    const [parentSelectValue, setParentSelectValue] = useState<any>(undefined);
    const [dataItemKey, setDataItemKey] = useState("key");
    const [textField, setTextField] = useState("value");

    const updateValueInternal = (val: any, desc: any) => {
        setInputValue(val);
        setInputDescription(desc);
        updateValue(template.Name, val);
    };

    useEffect(() => {

        let parentSelVal = undefined;
        let param = { ...selectParams };
        let paramName = "";
        if (template.Name === "QueryStatus") {
            parentSelVal = queryType;
            paramName = "QueryTypeID";
            param[paramName] = parentSelVal;
        }
        else if (template.Name === "EndDate") {
            if (inputValue && startDate && inputValue < startDate) {
                setInputValue(null);
            }
        }

        if (parentSelVal !== parentSelectValue) {
            setInputValue(null);
            setInputDescription("");
            setParentSelectValue(parentSelVal);
            getAPIOptions("", { key: paramName, value: param[paramName] });
        }
    }, [queryType, startDate]);

    useEffect(() => {
        setupComponent();
    }, []);

    const setupComponent = async () => {
        // set up the component here for getting initial values

        let storeIDList = [];
        if (template.Name === "Employee") {
            let storeIDresult = await Fetch.get({
                url: "/Store/GetEmployeeStores",
                params: {
                    employeeID: Storage.getCookie(Enums.Cookie.employeeID),
                    searchPhrase: ""
                }
            });
            storeIDList = storeIDresult.Results;
        }

        let inpTyp = null; //Enums.ControlType.Select;
        let selSrc = null; //"Enum";
        let selTyp = null; //"enum";
        let selHlp = null; //Enums.ControlType;
        let selPrms = {};
        let srchMth = "post";

        switch (template.Name) {
            // case "Customer":
            //     break;
            case "CustomerGroup":
                inpTyp = Enums.ControlType.Select;
                selSrc = "API";
                selTyp = "customer-group";
                selHlp = "/CustomerGroup/GetCustomerGroups";
                setLabel("Customer Group");
                setPlaceholder("Select customer group");
                setDataItemKey("ID");
                setTextField("Description");
                break;
            case "CustomerType":
                inpTyp = Enums.ControlType.Select;
                selSrc = "API";
                selTyp = "customer-type";
                selHlp = "/CustomerType/GetCustomerTypes";
                setLabel("Customer Type");
                setPlaceholder("Select customer type");
                setDataItemKey("ID");
                setTextField("Description");
                break;
            // case "Employee":
            //         IncludeDisabled: false,
            //         StoreIDList: storeIDList
            //     };
            //     break;
            case "FaultReason":
                inpTyp = Enums.ControlType.Select;
                selSrc = "API";
                selTyp = "fault-reason";
                selHlp = "/FaultReason/GetFaultReasons";
                setLabel("Fault Reason");
                setPlaceholder("Select fault reason")
                setDataItemKey("ID");
                setTextField("Description");
                break;
            // case "Inventory":
            //         IncludeClosed: false
            //     break;
            // case "JobCardStatus":
            //     break;
            // case "QueryStatus":
            //     break;
            // case "QueryType":
            //     break;
            case "Show":
                inpTyp = Enums.ControlType.Radio;
                setSelectOptions([
                    { key: "All", value: null },
                    { key: "Open", value: false },
                    { key: "Closed", value: true }
                ]);
                setLabel("Show");
                break;
            case "ShowClosed":
                inpTyp = Enums.ControlType.Checkbox;
                setInputValue(false);
                setLabel("Show Closed");
                break;
            // case "Store":
            //         employeeID: Storage.getCookie(Enums.Cookie.employeeID),
            //         searchPhrase: ""
            //     };
            //     break;
            // case "Supplier":
            //     break;
            case "StartDate":
                inpTyp = Enums.ControlType.Date;
                setLabel("Start Date");
                break;
            case "EndDate":
                inpTyp = Enums.ControlType.Date;
                setLabel("End Date");
                break;
        }

        // do this last to get options
        setSelectSearchMethod(srchMth);
        setSelectParams(selPrms);
        setSelectType(selTyp);
        setSelectSource(selSrc);
        setSelectHelper(selHlp);
        setInputType(inpTyp);
    };

    // to get API options
    const getAPIOptions = async (searchPhrase: any, ...others) => {
        let params = selectParams;
        if (selectType === "customer" || selectType === "inventory") {
            params.searchPhrase = searchPhrase;
        }
        if (Array.isArray(others)) {
            others.forEach((other: any) => {
                params[other.key] = other.value;
            })
        }
        let meth = selectSearchMethod === "post" ? Fetch.post : selectSearchMethod === "get" ? Fetch.get : null;
        if (selectHelper) {
            let response = await meth!({
                url: selectHelper,
                params: selectParams
            });
            setSelectOptions(response.Results);
        }
    };

    // to get Enum options
    const getEnumOptions = () => {
        let enumItems = Enums.getEnumItemsVD(selectHelper);
        setSelectOptions(enumItems);
    };

    function tryGetOptions() {
        if (selectSource === "API" && selectHelper) {
            getAPIOptions();
        } else if (selectSource === "Enum") {
            getEnumOptions();
        }
    }

    useEffect(() => {
        if (!inputType || !selectSource || !selectHelper || !selectType) return;

        if (inputType === Enums.ControlType.Select) {
            tryGetOptions();
        }

    }, [inputType, selectSource, selectHelper, selectType]);

    const handleSelectListChange = (e: any) => {
        let result = e.target.value;
        setInputDescription(result);
    };

    const updateSelectedValue = (val: any, desc: any) => {
        updateValueInternal(val, desc);
    };

    const updateSelectValueSC = (vals: any) => {
        setSelectedOptions(vals);
        let ids = vals.map((x: any) => x.ID);
        let id = ids.length > 0 ? ids[0] : null;
        updateValue(template.Name, id);
    }

    //     // for enums


    //     if (selectType === "enum-proper") {
    //     } else if (selectType === "enum") {
    //     } else if (inputType === Enums.ControlType.MultiSelect) {
    //         // multiselect

    //         if (valIdx > -1) {
    //         } else {
    //     } else {

    // };

    const updateRadioValue = (val: any) => {
        if (template.Name === "UserType") {
            updateValueInternal(val ? parseInt(val) : null);
        } else {
            updateValueInternal(val === "null" ? null : val.toString().toLowerCase() === "true");
        }
    };

    const getSelectDescription = (val: any) => {
        // for enums
        if (val === undefined || val === null) return "";
        let desc = "";
        if (selectSource === "Enum") {
            desc = Enums.getEnumStringValue(selectHelper, val);
        } else if (selectSource === "List") {
            desc = val;
        } else if (selectSource === "API") {
            switch (selectType) {
                case "employee":
                    desc = val.FirstName + " " + val.LastName;
                    break;
                case "customer":
                    desc = val.CustomerName;
                    break;
                case "status":
                    desc = val.map(function (opt: any) {
                        return opt.Description;
                    }).join(", ");
                    break;
                case "store":
                    desc = val.map(function (opt: any) {
                        return opt.Name;
                    }).join(", ");
                    break;
                case "supplier":
                    desc = val.Name;
                    break;
                default:
                    desc = val.Description;
                    break;
            }
        }

        return desc;
    };

    return (
        <div className="row" >
            <div className="row">
                {template.Name === "Customer" ? <>
                    <CustomerSelector
                        canChangeCustomer={true}
                        canClear={true}
                        selectedCustomer={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                        setSelectedCustomer={(e: any) => {
                            setSelectedOptions(e ? [e] : []);
                            updateValue(template.Name, e?.ID ?? null);
                        }}
                        inputErrors={{}}
                        compactView={true}
                        ignoreContactLocations={true}
                    />
                </>
                    :
                    template.Name === "Inventory" ? <>
                        <InventorySelector
                            selectedInventory={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                            setSelectedInventory={(e: any) => {
                                setSelectedOptions(e ? [e] : []);
                                updateValue(template.Name, e?.ID ?? null);
                            }}
                            ignoreAddOption={true}
                            placeholder="Search for an inventory item"
                        />
                    </>
                        :
                        template.Name === "Employee" ? <>
                            <EmployeeSelector
                                selectedEmployee={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                                setSelectedEmployee={(e: any) => {
                                    setSelectedOptions(e ? [e] : []);
                                    updateValue(template.Name, e?.ID ?? null);
                                }}
                                canClear={true}
                                placeholder="Select an employee"
                            />
                        </>
                            :
                            template.Name === "QueryType" ? <>
                                <QueryTypeSelector
                                    placeholder="Select a query type"
                                    required={false}
                                    selectedQueryType={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                                    setSelectedQueryType={(e: any) => {
                                        setSelectedOptions(e ? [e] : []);
                                        updateValue(template.Name, e?.ID ?? null);
                                    }}
                                    ignoreAddOption={true}
                                    canClear={true}
                                    includeDisabled={true}
                                />
                            </>
                                :
                                template.Name === "QueryStatus" ? <>
                                    <QueryStatusSelector
                                        placeholder="Select a query status"
                                        required={false}
                                        selectedQueryStatus={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                                        setSelectedQueryStatus={(e: any) => {
                                            setSelectedOptions(e ? [e] : []);
                                            updateValue(template.Name, e?.ID ?? null);
                                        }}
                                        ignoreAddOption={true}
                                        canClear={true}
                                        queryType={queryType}
                                        includeDisabled={true}
                                    />
                                </>
                                    :
                                    template.Name === "Supplier" ? <>
                                        <SupplierSelector
                                            selectedSupplier={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                                            setSelectedSupplier={(e: any) => {
                                                setSelectedOptions(e ? [e] : []);
                                                updateValue(template.Name, e?.ID ?? null);
                                            }}
                                            ignoreAddOption={true}
                                        />
                                    </>
                                        :
                                        inputType === Enums.ControlType.Select ?
                                            <>
                                                <SCDropdownList
                                                    label={label}
                                                    value={selectedOptions?.length > 0 ? selectedOptions[0] : null}
                                                    options={selectOptions}
                                                    onChange={(e: any) => { updateSelectValueSC(e ? [e] : []) }}
                                                    dataItemKey={dataItemKey}
                                                    textField={textField}
                                                    canClear={true}
                                                    placeholder={placeholder}
                                                    required={template.IsRequired}
                                                />
                                            </> : <></>}
                {template.Name === "Store" ? <>
                    <StoreMultiSelector
                        selectedStores={selectedOptions}
                        setSelectedStores={(e: any) => {
                            // updateSelectValueSC();
                            setSelectedOptions(e);
                            updateValue(template.Name, e.map((x: any) => x.ID));
                        }}
                    />

                </>
                    :
                    template.Name === "JobCardStatus" ? <>
                        <JobStatusMultiSelector
                            selectedJobStatuses={selectedOptions}
                            setSelectedJobStatuses={(e: any) => {
                                // updateSelectValueSC();
                                setSelectedOptions(e);
                                updateValue(template.Name, e.map((x: any) => x.ID));
                            }}
                        />

                    </>
                        :
                        inputType === Enums.ControlType.MultiSelect ? <>

                            <SCMultiSelect
                                label={label}
                                selectedOptions={selectedOptions}
                                availableOptions={selectOptions}
                                onChange={updateSelectValueSC}
                                dataItemKey={dataItemKey}
                                textField={textField}
                            />

                        </> : <></>}
                {inputType === Enums.ControlType.Checkbox ? <>
                    <div className="margin-top16">
                        <SCCheckbox
                            label={label} value={inputValue} onChange={(e: any) => { updateSelectedValue(!inputValue); }}
                        />
                    </div>
                </> : <></>}
                {inputType === Enums.ControlType.Radio ? <>
                    <div className="margin-top16">
                        <SCRadioButtonGroup
                            label={label}
                            value={inputValue?.toString() ?? "null"}
                            name={template.Name}
                            onChange={(e: any) => updateRadioValue(e.value)}
                        >
                            {selectOptions.map((opt: any, key: any) => {
                                return <SCRadioButton
                                    key={key}
                                    label={opt.key}
                                    value={opt.value?.toString() ?? "null"}
                                />
                            })}

                        </SCRadioButtonGroup>
                    </div>
                </> : <></>}
                {inputType === Enums.ControlType.Date ? <>
                    <SCDatePicker
                        label={label}
                        value={inputValue}
                        name={template.Name}
                        onChange={(e: any) => {
                            updateSelectedValue(e ? Time.toISOString(Time.updateTime(e, Time.today())) : e);
                        }}
                        canClear={true}
                        minDate={startDate}
                    />
                </> : <></>}
            </div>
            <style jsx>{`
                    .margin-top16 {
                        margin-top: 16px;
                    }
            `}</style>
        </div>
    );
};


export default ReportFilterInput;

/*
Name                    InputType   DataType        Implementation                          Done
CollectionArea          select      Guid?           API
CollectionStatus        select      Guid?           Enum
CollectionSubType       select      Guid?           Enum
CollectionType          select      Guid?           Enum
Concluded               select      Guid?           Show All, Concluded, Not Concluded
Customer                select      Guid?           API
CustomerGroup           select      Guid?           API
CustomerType            select      Guid?           API
Employee                select      Guid?           API
FaultReason             select      Guid?           API
Inventory               select      Guid            API
Inventory               select      Guid?           API
InventoryCategory       select      Guid?           API
InventorySubcategory    select      Guid?           API
JobCardStatus           multiselect List<Guid>      API
QueryStatus             select      Guid?           API
QueryType               select      Guid?           API
QuoteStatus             select      Guid?           Enum
Show                    radio       bool            Show All, Open, Closed
ShowClosed              boolean     bool            Boolean
Store                   select      Guid?           API
Supplier                select      Guid?           API
Technician              select      Guid?           API (All employees???)
UnitCount               select      int             Numbers from 0 - 50 in intervals of 5
UserType                radio       int             Enum (All, User, System, Communication)
StartDate   NOT CONFIGURED IN CONFIG TEMPLATE DB TABLE
EndDate     NOT CONFIGURED IN CONFIG TEMPLATE DB TABLE
*/
